import styled from "styled-components";

export const SelectContainer = styled.div`
    min-width: 250px;
`